import { NotificationRepostIcon } from '../NotificationIcons'
import NotificationDisplay from '../NotificationDisplay'

const RepostDisplayByUser = ({ user, posts, openPosts }) => {

  const handleClick = () => {
    // NOTE: remove_background turns the entire background black so we don't
    //       see the underlying screen bleed through the backnavigations
    openPosts({ remove_background: true }, { state: { posts, action: 'repost', user, }})
  }

  return (
    <NotificationDisplay
      Icon={NotificationRepostIcon}
      users={[user]}
      title={<span>{user?.displayName} reposted {posts.length} of your posts</span>}
      body={posts[0]?.body}
      clickCallback={handleClick}
      showAll
    />
  )
}

export default RepostDisplayByUser
